import gsap from "gsap";

import Resources from "./utils/Resources.js";
import World from "./world/World.js";

import sources from "./sources.js";
import Controls from "./world/Controls.js";

let instance = null;

export default class Experience {
  constructor (params) {

    if (instance) {
      return instance
    }

    instance = this;
    window.experience = instance;

    this.params = params;

    this.resources = new Resources(sources);
    this.controls = new Controls(
      document.querySelector(".world-container"),
      document.querySelector(".world")
    );

    this.preloader = {
      el: document.querySelector(".preloader"),
      progress: document.querySelector("#load-progress")
    }

    this.resources.on("update", () => {
      this.updatePreloader(this.resources.loaded / this.resources.toLoad);
    });

    this.resources.on("ready", () => {
      this.world = new World();

      this.controls.init();

      this.hidePreloader();
    });
  }

  updatePreloader (progress) {
    this.preloader.progress.textContent = (progress * 100).toFixed(0) + "%";
  }

  hidePreloader () {
    requestAnimationFrame(() => {
      gsap
      .timeline(
        {
          onComplete: () => {
            document.body.dataset.state = "loaded";
  
            gsap.from(".wrapper", { autoAlpha: 0, duration: 1, ease: "power4.inOut" });
          }
        }
      )
      .to(this.preloader.el, { autoAlpha: 0, ease: "power4.inout" }, 0.5)
    });
  }
}